import ReactDOM from 'react-dom';
import Root from '../tools/kidwk/index';

import '../../sass/apps/kidwk/kidwk.scss';

if (document.getElementById('kidwk-app')) {
  ReactDOM.render(<Root />, document.getElementById('kidwk-app'));
}
